import "es6-shim";
import * as React from 'react';
import "../../styles/ZipCodeConfirmation.css";
import { ConfirmationPopup } from "../genericComponents/ConfirmationPopup/ConfirmationPopup";
import RegionCodeValidator from "../../services/Validator/RegionCode/RegionCodeValidator";
import { LabelledMaskedInput } from "../customFormComponents/LabelledMaskedInput";
import { LabelledSelect } from "../customFormComponents/LabelledSelect";
import { useState } from "react";
import { CountryCodes } from "../../constants/countries";
import { ILabelSelect, IGenericsLang, IGeneralCountryMappedLang } from "../../services/Language/Types";
import { ErrorCodes } from "../../dtos/KioskDtos.dtos";

interface IZipCodeConfirmationProps {
    showModal: boolean,
    // countriesFromServer: Set<string>,
    text: IGenericsLang,
    countryMappedStrings: IGeneralCountryMappedLang
    isIncorrectPostalCode: boolean,
    countriesListOptions: Set<ILabelSelect>,
    isValid: boolean,
    zipCode: string;
    focusedElementId: string,
    onSubmit(zipCode: string): void,
    onRegionCodeChange(value: string): void,
    onFocus(mask: string): void,
    return(): void,
    showErrorCode(code: ErrorCodes, show: boolean): void,
}

export const ZipCodeConfirmation = (props: IZipCodeConfirmationProps) => {
    // Set state
    const [zipCode] = useState("");
    const [country, setCountry] = useState<CountryCodes>(CountryCodes.CA);
    const [mask, setMask] = useState(RegionCodeValidator.getRegionTextMaskByCountry(CountryCodes.CA));

    // Replaces componentWillMount or componentDidMount
    React.useEffect(() => {
        if (props.countriesListOptions.size > 0) {
            const it = props.countriesListOptions.values();
            const first = it.next();
            setCountry(first.value.value as CountryCodes);
            setMask(RegionCodeValidator.getRegionTextMaskByCountry(first.value.value.toString()));
        }
    }, [])

    // When mask is updated trigger prop function.
    React.useEffect(() => {
        props.onRegionCodeChange("");
    }, [mask])

    // When country is change we update the mask.
    React.useEffect(() => {
        updateMask();
    }, [country])
    /**
     * @name updateMask
     * @description updates the mask in the state depending on the country code.
     * @memberof ZipCodeConfirmation
     */
    const updateMask = () => {
        setMask(RegionCodeValidator.getRegionTextMaskByCountry(country))
    }

    /**
     * @name render
     * @description Main render function.
     * @returns {JSX.Element}
     * @memberof ZipCodeConfirmation
     */
    const textString = props.text;
    return (
        <ConfirmationPopup
            cancel={() => { props.return() }}
            confirm={() => { props.onSubmit(zipCode); }}
            title={textString.titles.PostalCodeConfirmationTitle}
            show={props.showModal}
            confirmButtonText={textString.labels.ConfirmButton}
            cancelButtonText={textString.labels.CancelButton}
            disableConfirmButton={!RegionCodeValidator.validateRegionCodeByCountry(country, props.zipCode) || props.zipCode.length === 0}
        >
            <div className="col-sm-12 text-center">
                {
                    props.countriesListOptions.size > 1 &&
                    <span>
                        <LabelledSelect
                            onChange={(value: CountryCodes) => { setCountry(value) }}
                            labelText={props.text.labels.CountryLabel}
                            id="countrySelect"
                            value={country}
                            options={Array.from(props.countriesListOptions)}
                            defaultValue={country}
                            onClick={() => { }}
                        />
                    </span>
                }
                <br />
            </div>
            <div className="col-sm-12">
                <LabelledMaskedInput
                    labelText={props.countryMappedStrings.regionCodeLabel[country]}
                    mask={mask}
                    value={props.zipCode}
                    erasable={false}
                    onChange={(value) => { props.onRegionCodeChange(value) }}
                    validationMessage={props.countryMappedStrings.regionCodeValidation[country]}
                    isValid={RegionCodeValidator.validateRegionCodeByCountry(country, props.zipCode) || RegionCodeValidator.getRegionCodeNumberOfCharacters(country) > props.zipCode.length}
                    onFocus={() => props.onFocus(mask)}
                    focused={props.focusedElementId === "regionCodeConfirmation"}
                />
                {
                    props.isIncorrectPostalCode &&
                    <p
                        className="text-center"
                        style={{ fontSize: "30px", color: "red" }}
                    >
                        {props.countryMappedStrings.regionCodeWrongEnteredValidation[country]}
                    </p>
                }

            </div>
        </ConfirmationPopup>
    );

}


// WEBPACK FOOTER //
// ./src/components/AcquireHealthCardNumber/ZipCodeConfirmation.tsx